import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { listToursForPartner } from '../modules/tours/api';

/**
 * #114 — the partner's task times only apply to orders WITHOUT their own
 * duration, and a tour copies its pickup / delivery duration onto every order
 * it resolves (OVO-120). BEAN's tours carried 3 min, so the 0.25-min partner
 * value never reached a delivery — list those tours next to the settings.
 */
export default function ServiceTimeOverridesNote({ partnerId }) {
  const { t } = useTranslation(['partners']);
  const [tours, setTours] = useState([]);

  useEffect(() => {
    if (!partnerId) return;
    listToursForPartner(partnerId)
      .then(({ response }) => setTours(Array.isArray(response) ? response : response?.tours || []))
      .catch(() => setTours([]));
  }, [partnerId]);

  const overriding = tours.filter(
    (tr) => tr.isActive !== false && ((tr.pickupDuration || 0) > 0 || (tr.defaultDeliveryDuration || 0) > 0),
  );
  if (!overriding.length) return null;

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: 12 }}
      data-testid="service-time-overrides"
      message={t('serviceTimes.overriddenTitle', { count: overriding.length })}
      description={
        <div>
          {overriding.map((tr) => (
            <div key={tr.id}>
              {t('serviceTimes.overriddenItem', {
                tour: tr.tourRef,
                detail: [
                  tr.pickupDuration > 0 ? t('serviceTimes.overriddenPickup', { mins: tr.pickupDuration }) : null,
                  tr.defaultDeliveryDuration > 0
                    ? t('serviceTimes.overriddenDelivery', { mins: tr.defaultDeliveryDuration })
                    : null,
                ]
                  .filter(Boolean)
                  .join(' · '),
              })}
            </div>
          ))}
          <div style={{ marginTop: 6 }}>{t('serviceTimes.overriddenFix')}</div>
        </div>
      }
    />
  );
}
